<template lang='pug'>
  include ./../../mixins
  div

    //- button(@click='toggleAll') All
    +b.margin_left_sm.margin_bottom_lg
      +b.tab-button.BUTTON(v-for='(item, index) in filterData' @click='change(item.category, index)' :class="{'is-active': activeIndex === index}") {{item.name}}
    
    +b.g-row--space_xl
      +b.g-cell.g-cols--12.--6-md.--4-lg.margin_vertical_xl.padding_horizontal_lg(v-for='item in renderArray')
        +b.portfolio.bgi-basic.display_block.A(:class="{'animation': animate}"  :href='item.link' target='_blank')
          +b.image-mask
          +b.img-basic.IMG(:src='item.img')
          +b.portfolio-hover.DIV
            +b.wysiwyg--white(v-html='item.content')

          +b.text_center.text-hover.fs_md.fs_lg-lg.color_white.font-weight_bold.z-index_2.position_relative.P {{item.name}}
          
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    filterData: {
      type: Array
    }
  },
  data() {
    return {
      renderArray: [],
      activeIndex: 0,
      animate: false,
    }
  },

  mounted() {
    this.change(this.filterData[0].category, 0)
    this.animate = true
    setTimeout(() => {
      this.animate = false
    }, 300)
  },
  
  methods: {
    change(category, index) {
      this.animate = true
      setTimeout(() => {
        this.animate = false
      }, 300)
      this.activeIndex = index
      console.log(this.activeTab)
      this.renderArray = []


      this.data.forEach((el, i) => {
        el.category.forEach(item => {
          if (item == category) {
            console.log(el)
            this.renderArray.push(el)
          }
        })
      })
      // } 
      console.log(this.renderArray)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/UiTabs/UiTabs.vue